import { Link } from "react-router-dom";
import Seal from "../seal";
import { useTranslation } from "../../../i18n/useTranslation";

const NoPage = () => {
  const { t } = useTranslation();
  return (
    <div className="band-hero section text-center">
      <Seal size={72} />
      <h1>{t("noPage.heading")}</h1>
      <div className="max-w-md mx-auto pt-3">
        <p className="mini">{t("noPage.body")}</p>
      </div>
      <Link to="/" className="btn-brass inline-block mt-4">{t("noPage.button")}</Link>
    </div>
  );
};

export default NoPage;
